export const Setting = {
  backendUrl: process.env.REACT_APP_BACKEND_URL,
  openaiKey: process.env.REACT_APP_OPENAI_KEY,
  voice: process.env.REACT_APP_VOICE_ENABLE,
  awsAccessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  awsSecretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  chargebeeKey: process.env.REACT_APP_CHARGEBEE_KEY
};
